import { render, staticRenderFns } from "./newCollectTarget.vue?vue&type=template&id=8f101970&scoped=true&"
import script from "./newCollectTarget.vue?vue&type=script&lang=js&"
export * from "./newCollectTarget.vue?vue&type=script&lang=js&"
import style0 from "./newCollectTarget.vue?vue&type=style&index=0&id=8f101970&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f101970",
  null
  
)

export default component.exports